module.exports = __webpack_public_path__ + "static/media/سیستم-مرکزی-فریونی-رک-در-هاپیرمالرکتها.d90514e1.jpg";